import { render, staticRenderFns } from "./copyToClipboardField.vue?vue&type=template&id=4bca197f&scoped=true"
import script from "./copyToClipboardField.vue?vue&type=script&lang=js"
export * from "./copyToClipboardField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bca197f",
  null
  
)

export default component.exports